import React, { useState } from 'react';
import { X } from 'lucide-react';
export function StickyBar() {
  const [isVisible, setIsVisible] = useState(true);
  if (!isVisible) return null;
  return <div className="relative z-50 bg-brand-black text-white px-4 py-3 flex items-center justify-center text-xs sm:text-sm md:text-base" data-id="element-205">
      <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-6 text-center max-w-7xl mx-auto w-full relative pr-8 md:pr-0" data-id="element-206">
        <p className="font-medium" data-id="element-207">
          Acceso con pago único solo en marzo → después pasa a membresía mensual
        </p>
        <a href="#" className="bg-brand-orange text-brand-black font-bold px-4 py-1.5 rounded-full text-sm animate-pulse-subtle hover:scale-105 transition-transform" data-id="element-208">
          Ingresar ahora
        </a>
        <button onClick={() => setIsVisible(false)} className="absolute right-0 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white p-1" aria-label="Cerrar" data-id="element-209">
          <X size={18} data-id="element-210" />
        </button>
      </div>
    </div>;
}